import React from 'react';
export const Hero = () => {
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="w-full min-h-screen pt-32 pb-24 px-6 md:px-10 relative flex items-center bg-gradient-to-br from-gray-50 to-white overflow-hidden" data-id="element-173">
      <div className="max-w-7xl mx-auto w-full relative z-10" data-id="element-174">
        <div className="grid lg:grid-cols-[1.2fr_1fr] gap-16 xl:gap-20 items-center" data-id="element-175">
          {/* Left - Typography */}
          <div className="space-y-8 order-2 lg:order-1 relative" data-id="element-176">
            <div className="text-[#3d8f5a] text-sm uppercase tracking-widest font-semibold flex items-center gap-2" data-id="element-177">
              <svg className="w-5 h-5" viewBox="0 0 100 100" fill="currentColor" data-id="element-178">
                <path d="M50 10 Q30 30 20 50 Q20 70 30 80 L40 85 L45 50 L50 85 L55 50 L60 85 L70 80 Q80 70 80 50 Q70 30 50 10 Z" data-id="element-179" />
              </svg>
              Клинический психолог
            </div>
            <div className="space-y-4 relative" data-id="element-180">
              <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-gray-900 leading-[0.9] tracking-tighter" data-id="element-181">
                МАРИЯ
              </h1>
              <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#3d8f5a] to-[#4a9d63] leading-[0.9] tracking-tighter" data-id="element-182">
                БРОДСКАЯ
              </h1>
            </div>
            <p className="text-base md:text-lg text-gray-700 font-light leading-relaxed max-w-lg" data-id="element-183">
              Индивидуальные консультации
              <br data-id="element-184" />
              Парные сессии
              <br data-id="element-185" />
              Групповая терапия и обучение
            </p>
            <button onClick={scrollToServices} className="px-6 py-3 bg-[#3d8f5a] text-white text-base font-semibold rounded-full hover:bg-[#2f7048] transition-all hover:scale-105 shadow-lg" data-id="element-186">
              Мои услуги
            </button>
          </div>
          {/* Right - Image */}
          <div className="relative order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-187">
            <div className="relative w-full max-w-md lg:max-w-lg" data-id="element-188">
              <div className="absolute inset-0 bg-gradient-to-br from-[#4a9d63] to-[#3d8f5a] rounded-3xl transform rotate-3" data-id="element-189"></div>
              <div className="relative rounded-3xl overflow-hidden transform -rotate-2 shadow-2xl" data-id="element-190">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eD39F9NpJ8XNvwc7Fo42Cj/8F8139AD-3ACE-4DA7-BADA-2B163CC75431.jpg" alt="Мария Бродская" className="w-full aspect-[4/5] object-cover" data-id="element-191" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Wave Element */}
      <div className="absolute bottom-0 left-0 w-full" data-id="element-192">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto" data-id="element-193">
          <path d="M0 48L60 56C120 64 240 80 360 80C480 80 600 64 720 56C840 48 960 48 1080 52C1200 56 1320 64 1380 68L1440 72V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V48Z" fill="#3d8f5a" fillOpacity="0.1" data-id="element-194" />
          <path d="M0 72L60 68C120 64 240 56 360 60C480 64 600 80 720 84C840 88 960 80 1080 72C1200 64 1320 56 1380 52L1440 48V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V72Z" fill="#3d8f5a" fillOpacity="0.15" data-id="element-195" />
        </svg>
      </div>
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#4a9d63] rounded-full opacity-5 blur-3xl pointer-events-none" data-id="element-196"></div>
    </section>;
};